var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Download = function Download(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 15 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'download'
      ),
      React.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M14 8v3.5c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5V8H0v3.5C0 12.878 1.122 14 2.5 14h10c1.378 0 2.5-1.122 2.5-2.5V8h-1' }),
        React.createElement('path', { d: 'M8 8.377V0H7v8.377L4.282 5.679l-.564.568L7.5 10l3.782-3.753-.564-.568L8 8.377' })
      )
    )
  );
};
/*eslint-enable */

export default Download;
//# sourceMappingURL=Download.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Download.js